<template>
  <div
      v-if="isVisible"
      transition="fade"
      :class="cssMainClasses"
      :data-object-name="objectName"
      :data-object-id="objectId"
  >
    <div v-if="selectable" class="gallerycard-selector">
      <i
          @click="onSelected($event)"
          @dblclick="onSelected($event)"
          class="brand-primary far fa-2x"
          :class="{'fa-circle' : !isSelected , 'fa-check-circle' : isSelected}"
      ></i>
    </div>
    <!--
              v-show="imageLoaded"
    -->
    <div class="gallerycard-thumbnail">
      <div class="gallerycard-thumbnail-container-img">
        <a v-if="src !== ''" v-bind:title="title" v-bind:href="fileViewSrc" target="contribution" draggable="false"
           @dragstart.prevent>
          <i v-if="!imageLoaded" class="fa fa-spinner fa-spin fa-3x"/>
          <img
              class="checkerboard"
              v-loadedifcomplete="imageLoaded"
              :src="src"
              :data-magnify-src="zoom"
              @load="onImageLoaded"
              @error="onImageError"
              @click="onImageClicked"
              @mouseover="onPreviewMouseOver"
              @mouseleave="onPreviewMouseLeave"
              draggable="false"
              loading="lazy"
              @dragstart.prevent
          />
        </a>
        <div v-else style="background: #efefef;min-height: 200px">
          <i class="fa fa-spinner fa-3x fa-spin"/>
        </div>
      </div>
    </div>
    <div class="gallerycard-title">
      <div class="gallerycard-title-table">
        <div class="gallerycard-title-row">
          <div class="gallerycard-name gallerycard-title-cell">
            <span class="title truncateTexte">
              <a
                  href="#"
                  v-if="metas && metas.values && metas.values.length>0"
                  v-on:mouseover="metasVisible=true"
                  v-on:mouseout="metasVisible=false"
              >
                <i class="fa fa-info-circle"></i>
              </a>
              <el-tooltip effect="light" :content="title" placement="bottom">
                  <span v-html="title"></span>
              </el-tooltip>
            </span>
          </div>
          <div class="gallerycard-action gallerycard-title-cell">
            <span
                v-if="typeof(status) !== 'undefined'"
                class="status display-status"
                v-bind:title="status.label"
                v-bind:style="{backgroundColor:status.color}"
            ></span>
            <a href="#" v-if="withBtnEdit" class="modify" @click="btnEditClicked"></a>
            <a href="#" v-if="withBtnView" class="zoom" @click="btnViewClicked"></a>

            <a v-if="withBtnFileView && typeof(fileViewSrc)!=='undefined'" v-bind:title="title"
               v-bind:href="fileViewSrc" target="contribution">
              <i class="far fa-eye fa-2x"></i>
            </a>

            <a
                v-if="withBtnActive"
                v-on:click="setActive"
                class="btn-load-form-data"
                :class="{'btn-load-form-data-active' : active }"
                title="Load form with this data"
                href="#"
            >
              <i class="far fa-play-circle fa-2x"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="metas && metasVisible" class="gallerycard-metas">
      <div v-if="typeof(metas.html) !== 'undefined'" v-html="metas.html"></div>
      <div v-if="typeof(metas.values) !== 'undefined'">
        <ul>
          <li v-for="meta in metas.values" :key="meta.name">
            <span class="truncateTexte" :data-field-type="meta.type" title="meta.name">
              <span v-if="!meta.withoutLabel" class="fieldname">
                <span v-html="meta.name"></span> :
              </span>
              <span class="fieldvalue" v-html="meta.value"></span>
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="gallerycard-bottom" v-if="!hideBottomMetas">
      <div class="gallerycard-bottom-table">
        <div class="gallerycard-bottom-row">
          <div
              v-if="metas && metas.bottom_left && metas.bottom_left !== ''"
              class="gallerycard-bottom-cell gallerycard-bottom-cell-left"
          >
            <span class="assetType" v-html="metas.bottom_left"></span>
          </div>
          <div
              v-if="metas && metas.bottom_right && metas.bottom_right !== ''"
              class="gallerycard-bottom-cell gallerycard-bottom-cell-right"
          >
            <span class="assetType" v-html="metas.bottom_right"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.gallerycard .gallerycard-selector {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
}
</style>

<style scoped>
.display-status {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 1px;
  margin-right: 5px;
  margin-top: 0px;
  border-radius: 12px;
  vertical-align: top;
  box-sizing: border-box;
}

</style>

<script>
export default {
  name: "wxm-gallery-card",
  directives: {
    loadedifcomplete: function(el, binding, vnode) {
      if (!binding.expression) {
        throw Error("loadedifcomplete: binding.expression absent");
      }
      if (el.complete) {
        vnode.context[binding.expression]=true;
      }
    }
  },
  props: {
    /**
     * Nom des classes par d�faut du div principal (articleBox)
     */
    defaultClassesNames: {
      type: Object,
      default: function () {
        return {
          articleBox: true,
          gallerycard: true
        };
      }
    },
    highlightClassName: String,
    /**
     * Eventuelle position de l'�v�nement dans la liste (ie. 52)
     */
    index: Number,
    visible: {
      type: Boolean,
      default: true
    },
    /**
     * Nom de l'objet (asset)
     */
    objectName: String,
    /**
     * ID de l'objet (ie : 277)
     */
    objectId: [Number, String],

    /**
     * Affiche un bouton d'activation (pouvant servir de rep�re dans une liste).
     * Cas d'usage, permet de savoir sur quel �v�nement l'utilisateur est positionn� dans
     * la liste
     * Lance un �v�nement set-active lorsqu'on clique sur le bouton
     */
    withBtnActive: Boolean,
    /**
     * Indique si l'�v�nement courant est actif
     */
    active: Boolean,

    /**
     * Affiche un bouton permettant d'afficher le fileview de l'instance dans une iframe
     */
    withBtnFileView: Boolean,

    /**
     * Affiche un bouton view et lance un �v�ment btn-view-clicked lorsque le bouton est cliqu�
     */
    withBtnView: Boolean,
    /**
     * Affiche un bouton edit et lance un �v�nement btn-view-clicked lorsque le bouton est cliqu�
     */
    withBtnEdit: Boolean,

    /**
     * Affiche l'indicateur de status
     * Si withStatus est true alors on s'attendra � ce que les variables statusName et statusColor soient
     * renseign�es
     */
    //withStatus:Boolean,
    status: {
      type: Object,
      default: function () {
        return {
          label: "",
          color: ""
        };
      }
    },

    /**
     * Source de l'image � afficher
     */
    src: String,

    fileViewSrc: String,

    /**
     * Source de l'image alternative permettant de zoomer sur la vignette d�finie par src
     * Pas r�ellement op�rationnel sans bidouillage aujourd'hui ....
     */
    zoom: String,

    /**
     * Permet d'activer la fonction de s�lection de l'�v�nement
     */
    selectable: Boolean,
    /**
     * Indique si l'�v�nement est s�lectionn� ou non
     */
    selected: Boolean,

    /**
     * Titre de la carte
     */
    title: String,

    /**
     * M�ta-donn�es affich�es sous le titre ... m�riterait d'�tre g�r� dans un composant � part ...
     * Format attendu :
     * {
     *     visible : true|false, // indique si les metas doivent �tre affich�es ou non
     *     values:[{
     *         name:'Nom de la meta',
     *         value:'Valeur de la meta',
     *         withoutLabel : true|false
     *     }]
     * }
     */
    metas: {
      type: Object,
      required: false,
      default: function () {
        return {
          visible: true,
          values: []
        };
      }
    },
    /**
     * Permet de cacher les m�tas-donn�es afin de limiter la hauteur de la carte.
     * Lorsque les m�tas-donn�es sont cach�es un picto apparait pr�t du titre et permet d'afficher
     * les m�tas lorsqu'on le survole
     */
    withMetasHiddable: Boolean,

    /**
     * Permet de cacher les metas gallery-bottom, utile pour le ViewSharedCart du panier V2
     */
    hideBottomMetas: {
      type: Boolean,
      default: function () {
        return false;
      }
    }
  },
  data: function () {
    var cssMainClasses = {...this.defaultClassesNames};
    if (this.highlightClassName) cssMainClasses[this.highlightClassName] = true;
    return {
      isSelected: this.selected,
      localMetasVisible: !this.withMetasHiddable,
      imageLoaded: false,
      imageLoadedOnError: false,
      cssMainClasses
    };
  },
  watch: {
    selected: function (value) {
      this.isSelected = value;
    }
    , src:function(value) {
      /*
      chgt donc impactons, faudrait arriver � effacer l'img pr�c�dente mais ne sait pas faire ...
      */
      this.imageLoaded=false;
    }
  },
  computed: {
    isVisible: function () {
      return this.visible;
    },
    metasVisible: {
      get: function () {
        return this.localMetasVisible;
      },
      set: function (value) {
        this.localMetasVisible = value;
      }
    },
    /*
    metasVisible: function() {
      return !this.withMetasHiddable;
    },
    */
    itemData: function () {
      var data = {
        index: this.index
      };
      if (typeof this.objectName !== "undefined") {
        data["objectName"] = "" + this.objectName;
      }
      if (typeof this.objectId !== "undefined") {
        data["objectId"] = "" + this.objectId;
      }
      return data;
    }
  },
  methods: {
    async _emit(eventName, event, ext) {
      //var data = this.itemData;
      /*
                var data = {
                    ...this.itemData,
                    ...ext || {}
                }
                 */
      var data = $.extend(true, {}, this.itemData || {}, ext || {});
      if (event) {
        data = $.extend(true, {}, data, {
          event: event
        });
        /*
                    data = {
                        ...data,
                        event
                    }
                    */
      }
      this.$emit(eventName, data);
    },
    onSelected(event) {
      this.isSelected = !this.isSelected;
      this._emit("set-selected", event, {value: this.isSelected});
    },

    /**
     * L�ve un �v�nement btn-edit-clicked lorsque le bouton edit est cliqu� par l'utilisateur
     */
    btnEditClicked: function (event) {
      this._emit("btn-edit-clicked", event);
    },

    /**
     * L�ve un �v�nement btn-view-clicked lorsque le bouton view est cliqu� par l'utilisateur
     */
    btnViewClicked: function (event) {
      this._emit("btn-view-clicked", event);
    },

    /**
     * L�ve un �v�nement preview-mouse-over lorsque l'utilisateur survole l'image de pr�visualisation
     * Permet de g�rer les zooms par exemple
     */
    onPreviewMouseOver: function (event) {
      this._emit("preview-mouse-over", event);
    },
    /**
     * L�ve un �v�nement preview-mouse-leave lorsque l'utilisateur ne survole plus l'image de pr�visualisation
     * Permet de g�rer les zooms par exemple
     */
    onPreviewMouseLeave: function (event) {
      this._emit("preview-mouse-leave", event);
    },
    /**
     * L�ve un �v�nement image-clicked lorsque l'image de pr�visualisation est cliqu�e par l'utilisateur
     */
    onImageClicked: function (event) {
      this._emit("image-clicked", event);
    },

    /**
     * L�ve un �v�nement image-loaded lorsque l'image de pr�visualisation a �tre charg�e
     */
    onImageLoaded: function (event) {
      this.imageLoadedOnError=false;
      this.imageLoaded = true;
      this._emit("image-loaded", event);
    },
    onImageError: function(event) {
      this.imageLoadedOnError=true;
      this.imageLoaded = true;
      this._emit("image-loaded", event);
    },

    /**
     * L�ve un �v�nement set-active lorsque l'utilisateur clique sur le bouton d'activation de l'item
     */
    setActive: function (event) {
      this._emit("set-active", event);
    },
    noop() {

    }
  }
};
</script>
